var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviousPageDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75486 18.508C5.45297 18.508 1.95097 15.006 1.95097 10.7041C1.95097 6.40219 5.45297 2.90019 9.75486 2.90019C14.0568 2.90019 17.5588 6.40219 17.5588 10.7041C17.5588 15.006 14.0568 18.508 9.75486 18.508ZM9.75486 20.4589C15.1395 20.4589 19.5097 16.0888 19.5097 10.7041C19.5097 5.3194 15.1395 0.949219 9.75486 0.949219C4.37018 0.949219 0 5.3194 0 10.7041C0 16.0888 4.37018 20.4589 9.75486 20.4589ZM8.77938 10.7041V14.606H10.7303V10.7041H13.6568L9.75486 6.80214L5.85292 10.7041H8.77938Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPageDisabled);
export default __webpack_public_path__ + "static/media/previous-page-disabled.ccceef4698bae680b77b6f6da3ad58f2.svg";
export { ForwardRef as ReactComponent };